import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AddStock from "@/pages/AddStock";
import StockDetail from "@/pages/StockDetail";
import History from "@/pages/History";
import DayView from "@/pages/DayView";
import LearnedModel from "@/pages/LearnedModel";
import Settings from "@/pages/Settings";
import "@/index.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-app flex items-center justify-center text-muted-1 text-sm">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/add" element={<Protected><AddStock /></Protected>} />
      <Route path="/stock/:id" element={<Protected><StockDetail /></Protected>} />
      <Route path="/history" element={<Protected><History /></Protected>} />
      <Route path="/day/:date" element={<Protected><DayView /></Protected>} />
      <Route path="/learned" element={<Protected><LearnedModel /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    // `translate="no"` prevents browser auto-translation from mutating DOM
    // outside React's control (root cause of intermittent removeChild errors).
    <div translate="no" className="notranslate">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  background: "var(--card)",
                  border: "1px solid var(--border-strong)",
                  color: "var(--text)",
                },
              }}
            />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}
